module.exports = __webpack_public_path__ + "static/media/latam-internacional.0ddd2677.png";